import Layout from '@/components/feature/Layout';

export default function PrivacidadPage() {
  return (
    <Layout>
      {/* Hero header with image background */}
      <div className="relative py-16 md:py-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=clean%20minimalist%20digital%20privacy%20concept%2C%20abstract%20padlock%20symbol%20with%20soft%20focus%20background%2C%20warm%20natural%20lighting%2C%20professional%20editorial%20photography%2C%20soft%20neutral%20earthy%20tones%2C%20simple%20composition%20with%20space%20for%20text&width=1800&height=600&seq=privacidad-hero-secure&orientation=landscape"
            alt="Privacidad y protección de datos"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60" />
        </div>
        <div className="relative z-10 w-full px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-300 mb-3">
            Legal
          </span>
          <h1 className="font-heading font-bold text-3xl md:text-5xl text-white mb-4">
            Política de Privacidad
          </h1>
          <p className="text-white/70 text-sm md:text-base max-w-2xl mx-auto">
            Cómo protegemos y manejamos la información de nuestros usuarios afiliados.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="w-full px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-8">
            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                1. Información que Recolectamos
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                CODESAJAN recolecta únicamente la información necesaria para la prestación del servicio de agua y la gestión administrativa de nuestros afiliados. Esto incluye: nombre del titular, dirección del domicilio, número de teléfono de contacto, código de usuario y registro histórico de consumo de agua. Toda la información es proporcionada voluntariamente por el afiliado al momento de su registro.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                2. Uso de la Información
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                La información recolectada se utiliza exclusivamente para fines administrativos internos del comité: facturación del servicio de agua, notificación de lecturas de medidores, comunicación de avisos importantes sobre el servicio y atención de consultas y reclamos. No compartimos, vendemos ni distribuimos información de nuestros afiliados a terceros bajo ninguna circunstancia.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                3. Protección de Datos
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Implementamos medidas de seguridad administrativas y técnicas para proteger la información personal de nuestros afiliados contra accesos no autorizados, alteración, divulgación o destrucción. Los registros físicos se mantienen en archivos seguros dentro de nuestras oficinas, y los registros digitales cuentan con acceso restringido únicamente al personal autorizado de la directiva.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                4. Derechos del Usuario
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Como afiliado, usted tiene derecho a solicitar información sobre los datos que mantenemos en nuestros registros, solicitar la corrección de datos inexactos y solicitar la eliminación de su información personal una vez finalizada su relación como afiliado al comité, conforme a la normativa interna vigente.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                5. Uso de Cookies
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Nuestro sitio web puede utilizar cookies esenciales para mejorar la experiencia de navegación. Estas cookies no contienen información personal identificable y son utilizadas exclusivamente para fines de funcionamiento técnico del sitio. El usuario puede configurar su navegador para rechazar cookies si así lo prefiere, aunque esto podría afectar algunas funcionalidades del sitio.
              </p>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-foreground-950 mb-3">
                6. Contacto sobre Privacidad
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Para mayor detalle sobre nuestra política de privacidad, ejercer sus derechos sobre sus datos personales, o consultar aspectos específicos de la reglamentación interna del comité en materia de protección de datos, comuníquese directamente con la directiva de CODESAJAN a través de nuestros canales oficiales.
              </p>
            </section>

            <div className="mt-12 p-6 rounded-xl bg-accent-50 border border-accent-100">
              <div className="flex items-start gap-3">
                <i className="ri-information-line text-accent-600 text-lg w-5 h-5 flex items-center justify-center shrink-0 mt-0.5"></i>
                <div>
                  <p className="text-sm font-semibold text-foreground-950 mb-1">Información Importante</p>
                  <p className="text-sm text-foreground-600">
                    Este documento presenta un resumen general de nuestra política de privacidad. Para información detallada, aspectos legales específicos y la reglamentación completa del comité, le solicitamos contactar directamente con la directiva de CODESAJAN en nuestras oficinas durante el horario de atención.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}